import ClosedMonthApi from '../../../api/closed_month.js';

const getBaseEvidenceClosedMonth = () => ({
  month: null,
  year: null,
  is_closed: 1,
  description: null,
  mail_send_at: null,
});

const state = {
  evidenceclosedmonth: getBaseEvidenceClosedMonth(),
  date_period: null,
};

const getters = {};

const actions = {
  resetEvidenceClosedMonthToBase({ commit, state }, payload = {}) {
    commit('setEvidenceClosedMonth', {
      ...getBaseEvidenceClosedMonth(),
      ...payload,
    });
  },

  indexClosedMonth({ commit }, url) {
    return new Promise((resolve, reject) => {
      ClosedMonthApi.indexClosedMonth(url).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  updateClosedMonth({ commit, state }, closedMonth) {
    return new Promise((resolve, reject) => {
      ClosedMonthApi.updateClosedMonth(closedMonth).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};

const mutations = {
  setEvidenceClosedMonth(state, closedMonth) {
    state.evidenceclosedmonth = closedMonth;
  },
  updateEvidenceClosedMonth(state, payload) {
    state.evidenceclosedmonth = {
      ...state.evidenceclosedmonth,
      ...payload,
    };
  },
  setDatePeriod(state, date_period) {
    state.date_period = date_period;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
